import { go, html, map } from 'fxjs/es';
import { NessLabsFrameF } from '@modules/NessLabs/Frame/F';
import { productDetailSelectedOptionGroupChanged } from '@modules/MShop/App/ProductDetail/CustomEvent/custom-event.ts';
import { BpOptionGroups, BpOptions, SelectedOptionGroups } from '@services/database/mco/schema/public';
import { selectedOptionGroupUtil } from '@modules/BpOption/S/Function/selected-option-group.util.ts';
import {
  makeNessFrameOptionSelectorHtml,
  showNessSelectedFrameOptionsHtml,
} from '@modules/MShop/App/ProductDetail/S/Tmpl/partials/productDetailForm';
import { $find } from 'fxdom/es';
import { AssocBpOptionGroup, bpOptionUtil } from '@modules/BpOption/S/Function/bp-option.util.ts';
import { computePosition } from '@floating-ui/dom';

const option_contents = (bp_options: BpOptions[], selected_option_id: number) => {
  const selected_bp_option = bp_options.find((opt) => Number(opt.id) === selected_option_id);
  const rest_option = bp_options.filter((option) => Number(option.id) !== selected_option_id);

  return html`<div class="ness-frame-option__selected" data-id="${selected_option_id}">
      ${selected_bp_option?.name}
    </div>
    ${go(
      rest_option,
      map(
        (option: BpOptions) =>
          html`<div class="ness-frame-option__non-selected" data-id="${option.id}">${option.name}</div>`,
      ),
    )}`;
};

export const floatingUI = (parent_el: HTMLElement, bp_option_group: BpOptionGroups, selected_id: number) => {
  let drop_el: HTMLElement | null = null;

  const openDropdown = () => {
    if (drop_el) {
      return;
    }

    const {
      _: { bp_options },
    } = bp_option_group;
    const selected_option_id = Number(selected_id);
    const contents = option_contents(bp_options, selected_option_id);
    drop_el = document.createElement('div');
    drop_el.classList.add('ness-frame-option');
    drop_el.innerHTML = contents;

    parent_el.style.border = '1px solid white';
    parent_el.appendChild(drop_el);

    computePosition(parent_el, drop_el, {
      placement: 'bottom-start',
      middleware: [],
    }).then(() => {
      Object.assign(drop_el!.style, {
        top: '0px',
        left: '0px',
        zIndex: '999',
      });
    });

    document.addEventListener('click', (e) => {
      // 외부영역 클릭해서 드롭박스 닫기
      const target = e.target as HTMLElement;
      if (!parent_el.contains(target)) {
        closeDropdown();
      }
    });

    // 드롭박스 내부 클릭에 따라 값 전달 후 박스 닫기
    drop_el.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      if (parent_el.contains(target)) {
        const option_el = $find('.ness-frame-option__non-selected', parent_el);
        if (option_el) {
          selectOptionId(e);
          closeDropdown();
        } else {
          closeDropdown();
        }
      }
    });
  };

  const selectOptionId = (e: MouseEvent) => {
    const target = e.target as Element;
    const clickedOption = target.closest('.ness-frame-option__non-selected');
    if (clickedOption) {
      const new_selected_option_id = Number(clickedOption.getAttribute('data-id'));
      NessLabsFrameF.SelectedOptionGroupForFrameCharacter.setBpOptionOutputForBpOptionId(
        new_selected_option_id,
      );
      productDetailSelectedOptionGroupChanged.dispatch();
    }
  };

  const closeDropdown = () => {
    const is_mobile = box.sel('is_mobile');
    if (!drop_el) return;

    parent_el.removeChild(drop_el);
    drop_el = null;
    if (is_mobile) {
      parent_el.style.border = '1px solid #000';
    } else {
      parent_el.style.border = '1px solid #a2a2a2';
    }
  };

  // 드롭다운 박스 열기
  parent_el?.addEventListener('click', openDropdown);
};

export const renderUiProductSubTitle = (el: HTMLElement) => {
  const target_el = el.querySelector('.pd-product__bp-name');
  if (!target_el) return;
  const bp_option_groups = box.sel('product_detail->base_product->_->bp_option_groups');
  const selected_option_group = box.sel('product_detail->selected_option_group');
  const selected_bp_option_ids = selected_option_group.bp_option_ids;

  const result = selectedOptionGroupUtil.getSelectedOptionGroupAndOptionByDevName(
    bp_option_groups,
    selected_bp_option_ids,
    'NESS_FRAME',
  );
  const selected_frame_option: BpOptions | null = result?.bp_option ?? null;
  if (!selected_frame_option) return;

  const value: string = selected_frame_option.name;
  const display_value = value === '선택 안함' ? `액자 ${value}` : `액자 사이즈 ${value}`;
  target_el.innerHTML = display_value;
};

export const renderUiProductOptionInfos = (
  el: HTMLElement,
  bp_option_groups?: AssocBpOptionGroup[],
  selected_option_group?: SelectedOptionGroups,
) => {
  const target_el = el.querySelector('.ness-frame-options');
  if (!target_el) return;

  const profit = box().product_detail.product_color.profit;

  const option_info = showNessSelectedFrameOptionsHtml(selected_option_group, bp_option_groups, profit);
  target_el.innerHTML = option_info;
};

export const renderUiProductFrameOption = (el: HTMLElement) => {
  const target_el = $find('[name="ness-custom-frame"]', el);
  if (!target_el) return;
  const bp_option_groups = box.sel('product_detail->base_product->_->bp_option_groups');
  const selected_option_group = box.sel('product_detail->selected_option_group');
  const selected_bp_option_ids = selected_option_group.bp_option_ids;

  const result = selectedOptionGroupUtil.getSelectedOptionGroupAndOptionByDevName(
    bp_option_groups,
    selected_bp_option_ids,
    'NESS_FRAME',
  );
  const selected_frame_option: BpOptions | null = result?.bp_option ?? null;
  if (!selected_frame_option) return;

  const selected_option = makeNessFrameOptionSelectorHtml(bp_option_groups, selected_bp_option_ids);
  target_el.outerHTML = selected_option;
  nessFrameSelectOptionEvent(el);
};

export const nessFrameSelectOptionEvent = (el: HTMLElement) => {
  const parent_el = $find('.ness_frame_option-container', el) as HTMLElement;
  const product_detail = box.sel('product_detail');
  const bp_option_groups = product_detail.base_product._.bp_option_groups;
  const bp_option_group = bpOptionUtil.getBpOptionGroupByDevName(bp_option_groups, 'NESS_FRAME');
  if (!bp_option_group) return;
  const selected_bp_option_ids = product_detail.selected_option_group?.bp_option_ids;
  const selected_bp_option = bp_option_group._.bp_options.find((bp_option) =>
    selected_bp_option_ids.includes(bp_option.id),
  );
  if (!selected_bp_option) return;

  floatingUI(parent_el, bp_option_group, selected_bp_option.id);
};
